"use client";
import { Tag, Typography } from "antd";

const { Text } = Typography;

const CollateralPreview = (props) => {
  const {
    formData,
    currencySymbol,
    ownershipTypeOptions,
    collateralTypeOptions,
    exposureTypeOptions,
    currencyOptions,
    valuationMethodOptions,
  } = props;
  console.log(formData);
  const getLabelFromOptions = (options, value) =>
    options?.find((opt) => opt.value === value)?.label || value;

  const ownershipTypeValue =
    formData?.ownershipDetails?.ownershipType ?? formData?.ownershipType;
  const collateralTypeValue =
    formData?.classification?.collateralType ?? formData?.collateralType;
  const exposureTypeValue =
    formData?.classification?.exposureType ?? formData?.exposureType;
  const currencyValue = formData?.valuation?.currencyCode ?? formData?.currency;
  const valuationMethodValue =
    formData?.valuation?.valuationMethods ?? formData?.valuationMethod;

  const formatFullDate = (date) => {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const data = [
    {
      section: "Collateral Overview",
      items: [
        {
          name: "Collateral Name",
          value: formData?.collateralOverview?.collateralName || "-",
        },
        {
          name: "Collateral Description",
          value: formData?.collateralOverview?.description || "-",
        },
        {
          name: "Issuer Code (Securities)",
          value: formData?.collateralOverview?.issuerCode || "-",
          isOptional: true,
        },
        {
          name: "Ownership Verified",
          value: formData?.collateralOverview?.ownershipVerified || "-",
          isTag: true,
        },
        {
          name: "Registration Date",
          value: formatFullDate(formData?.collateralOverview?.registrationDate),
        },
      ],
    },
    {
      section: "Ownership Details",
      items: [
        {
          name: "Ownership Type",
          value:
            ownershipTypeValue !== undefined && ownershipTypeValue !== null
              ? getLabelFromOptions(ownershipTypeOptions, ownershipTypeValue)
              : "-",
          isTag: true,
        },
        {
          name: "Documents",
          value: formData?.ownershipDetails?.documents?.length
            ? `${formData.ownershipDetails.documents.length} file(s) selected`
            : "No documents uploaded",
        },
      ],
    },
    {
      section: "Collateral Classification",
      items: [
        {
          name: "Collateral Type",
          value:
            collateralTypeValue !== undefined && collateralTypeValue !== null
              ? getLabelFromOptions(collateralTypeOptions, collateralTypeValue)
              : "-",
          isTag: true,
        },
        {
          name: "Exposure Type",
          value:
            exposureTypeValue !== undefined && exposureTypeValue !== null
              ? getLabelFromOptions(exposureTypeOptions, exposureTypeValue)
              : "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Collateral Valuation",
      items: [
        {
          name: "Currency",
          value:
            currencyValue !== undefined && currencyValue !== null
              ? getLabelFromOptions(currencyOptions, currencyValue)
              : "-",
          isTag: true,
        },
        {
          name: "Collateral Nominal Value",
          value: formData?.valuation?.nominalValue
            ? `${currencySymbol || ""}${formData.valuation.nominalValue.toLocaleString()}`
            : "-",
        },

        {
          name: "Valuation Methods",
          value:
            valuationMethodValue !== undefined && valuationMethodValue !== null
              ? getLabelFromOptions(
                  valuationMethodOptions,
                  valuationMethodValue,
                )
              : "-",
          isTag: true,
        },
        {
          name: "Periodic Revaluation",
          value: formData?.valuation?.periodicRevaluation ? true : false,
          isTag: true,
        },
        {
          name: "Historical Valuation Tracking",
          value: formData?.valuation?.historicalTracking ? true : false,
          isTag: true,
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>;
    }

    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {String(value).replace(/_/g, " ")}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem = index === (data[section]?.items?.length || 0) - 1;

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ fontWeight: 600 }}>{item.value}</Text>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "700",
          margin: 0,
          marginBottom: "24px",
        }}
      >
        Preview
      </h1>

      {data.map((section, sectionIndex) => (
        <div key={section.section}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            {section.section}
          </h2>
          <div
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              marginBottom: "24px",
            }}
          >
            {section.items.map((item, index) =>
              renderRow(item, index, sectionIndex),
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CollateralPreview;
